import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "What do you want to do", -1)
const _hoisted_2 = { class: "q-pa-md q-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "q-pa-md" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "row items-center q-pb-none" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_q_space),
          _withDirectives(_createVNode(_component_q_btn, {
            icon: "close",
            flat: "",
            round: "",
            dense: ""
          }, null, 512), [
            [_directive_close_popup]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_btn, {
              label: "Add new member",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('newMember'))),
              color: "primary",
              unelevated: "",
              "no-caps": ""
            }),
            _createVNode(_component_q_btn, {
              label: "Find member",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('searchForMember'))),
              color: "primary",
              unelevated: "",
              "no-caps": ""
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}